module.exports = __webpack_public_path__ + "media/images/dummys/noimage-0047495a51b2abd5fe4b4624c4962d84.jpg";